import * as GenericRedux from 'generic/genericRedux'
import { isNil } from 'lodash'
import * as React from 'react'
import { TemplateModule } from 'shared_server_client/types/email_layout'
import { EditSectionProps } from '../components'
import {
  MenuSections,
} from '../constants'
import '../styles.scss'
import { SurveyFontEditor, SurveyContainerEditor } from './colors'
import { ModuleAction } from './templateModule'

interface SECProps extends EditSectionProps {
  context?: any,
  staticTextType: string,
}

interface SurveyEditorExtraProps extends TemplateModule {
  selectSection?: any,
  onModulePropsChange?: any,
}

type SurveyEditorProps = GenericRedux.AllComponentPropsWithModal<any> & SECProps & SurveyEditorExtraProps

export class SurveyEditor extends React.Component<SurveyEditorProps, any> {
  constructor(props: any) {
    super(props)
    this.handleModuleChange = this.handleModuleChange.bind(this)
    this.getModuleConfig = this.getModuleConfig.bind(this)
  }

  public render() {
    const { context } = this.props
    
    return context ? <div className="static-content-wrapper">
    <div className="go-back" onClick={() => this.goBack()}>&lt; &nbsp; Go back</div>
    <div className="title-description-and-toggle-container">
      <div className="title-and-toggle-container">
        <div className="title">
          Survey Styling
        </div>
      </div>
      
      <div className="section section-color-editor">
        <br></br>
        <SurveyFontEditor type="surveyQuestion"
          getConfig={this.getModuleConfig}
          label="Survey Question"
          onChange={(k: string, v: string) => this.handleModuleChange(k, v)} />
      </div>
      
      <div className="section section-color-editor">
        <br></br>
        <SurveyFontEditor type="surveyAnswer"
          getConfig={this.getModuleConfig}
          label="Survey Answers"
          onChange={(k: string, v: string) => this.handleModuleChange(k, v)} />
      </div>
      
      <div className="section section-color-editor">
        <br></br>
        <SurveyContainerEditor 
          getConfig={this.getModuleConfig}
          onChange={(k: string, v: string) => this.handleModuleChange(k, v)} />
      </div>
      
    </div>
        </div> : <div></div>
  }

  private goBack() {
    this.props.selectSection(MenuSections.layout)
  }
  
  private getModuleConfig = (config: string, defaultValue: any = '', defaultConfig: string = '') => {
    const templateModule = this.getCurrentTemplateModule()
    if (templateModule.moduleConfig && !isNil(templateModule.moduleConfig[config])) {
      return templateModule.moduleConfig[config]
    }

    if (defaultConfig && !isNil(this.props.data[defaultConfig])) {
      return this.props.data[defaultConfig]
    }

    return defaultValue
  }

  private getCurrentTemplateModule = () => {
    return this.props.context ? this.props.data.template_modules.filter((x) => x.type === this.props.context.type
      && x.sequence === this.props.context.sequence)[0] || this.props.context : {}
  }

  private handleModuleChange = (config: string, value: any) => {
    const templateModule: TemplateModule = this.getCurrentTemplateModule()
    templateModule.moduleConfig[config] = value
    this.props.onModulePropsChange({
      action: ModuleAction.edit,
      module: templateModule,
    })
  }
}